import ToolTip, { ITooltipProps } from '@/shared/Common/Tooltip'
import QuestionIcon from '../../../assets/icons/information.svg?react'
import css from './questionIcon.module.css'

const QuestionIconWithTooltip = (props: ITooltipProps) => {
  return (
    <ToolTip {...props}>
      <div className={css.wrapper}>
        <QuestionIcon className={css.icon} />
      </div>
    </ToolTip>
  )
}

export default QuestionIconWithTooltip
